











































































































































import { Component, Prop } from 'vue-property-decorator';
import { CSSStyleOptions } from '../common-types';
import { SwExtendedVue } from '../sw-extended-vue';

@Component
export default class SwTooltip extends SwExtendedVue {
  @Prop({ type: Boolean, default: false })
  compact: boolean;

  @Prop({ type: Number, default: 200 })
  maxWidth: number;

  @Prop({ type: Number, default: 180 })
  maxHeight: number;

  cssPrefix: string = 'sw-tooltip';

  get innerStyle(): CSSStyleOptions {
    return {
      maxHeight: `${this.maxHeight}px`,
      maxWidth: `${this.maxWidth}px`,
    };
  }
}
